const markConfig = {
    "iotHost":"a1x0stvb5fs5tb-ats.iot.ap-northeast-1.amazonaws.com"
};


export default markConfig;